import React from 'react';
import { TrendingUp, TrendingDown, Calendar, ChevronRight, Share2 } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { formatPrice, formatDate } from '../utils/formatters';

const TradeCard = ({ trade, onClick, showStatus = true, onShare }) => {
  const { colors } = useTheme();

  const isProfit = trade.pnl >= 0;
  const symbol = trade.symbol?.replace('.NS', '') || '';

  return (
    <button
      onClick={onClick}
      className="app-card w-full rounded-lg p-2.5 text-left transition-all active:scale-[0.98]"
      style={{ background: `linear-gradient(135deg, ${colors.accent}12 0%, ${colors.accent}04 100%)`, borderWidth: '1px', borderColor: colors.border }}
      data-testid={`trade-card-${trade.id}`}
    >
      <div className="flex items-start justify-between mb-2">
        <div>
          <p className="font-semibold text-sm" style={{ color: colors.primaryText }}>{symbol}</p>
          <p className="text-[13px]" style={{ color: colors.secondaryText }}>{trade.company || trade.company_name}</p>
        </div>
        <div className="flex items-center space-x-1.5">
          {showStatus && (
            <span className="text-[13px] px-1.5 py-0.5 rounded font-medium" style={{ backgroundColor: `${colors.profit}20`, color: colors.profit }}>
              {trade.status || 'Closed'}
            </span>
          )}
          <ChevronRight className="w-3.5 h-3.5" style={{ color: colors.secondaryText }} />
        </div>
      </div>
      
      <div className="grid grid-cols-3 gap-1.5 text-xs mb-2">
        <div>
          <p className="text-[13px]" style={{ color: colors.secondaryText }}>Entry</p>
          <p className="font-medium text-xs" style={{ color: colors.primaryText }}>{formatPrice(trade.buyPrice || trade.entry_price || trade.price)}</p>
        </div>
        <div>
          <p className="text-[13px]" style={{ color: colors.secondaryText }}>Exit</p>
          <p className="font-medium text-xs" style={{ color: colors.primaryText }}>{formatPrice(trade.sellPrice || trade.exit_price)}</p>
        </div>
        <div>
          <p className="text-[13px]" style={{ color: colors.secondaryText }}>P&L</p>
          <div className="flex items-center space-x-0.5">
            {isProfit ? <TrendingUp className="w-2.5 h-2.5" style={{ color: colors.profit }} /> : <TrendingDown className="w-2.5 h-2.5" style={{ color: colors.loss }} />}
            <p className="font-medium text-xs" style={{ color: isProfit ? colors.profit : colors.loss }}>{isProfit ? '+' : ''}{formatPrice(trade.pnl)}</p>
          </div>
        </div>
      </div>

      {trade.quantity && (
        <div className="flex items-center justify-between text-[13px] mb-1.5" style={{ color: colors.secondaryText }}>
          <span>Qty: {trade.quantity}</span>
          {trade.pnlPct && <span style={{ color: isProfit ? colors.profit : colors.loss }}>{isProfit ? '+' : ''}{trade.pnlPct.toFixed(2)}%</span>}
        </div>
      )}
      
      {trade.strategyTags && trade.strategyTags.length > 0 && (
        <div className="flex flex-wrap gap-1 mb-1.5">
          {trade.strategyTags.slice(0, 3).map((tag, idx) => (
            <span key={idx} className="text-[13px] px-1 py-0.5 rounded" style={{ backgroundColor: `${colors.accent}15`, color: colors.accent }}>{tag}</span>
          ))}
        </div>
      )}
      
      <div className="flex items-center justify-between text-[13px]" style={{ color: colors.secondaryText }}>
        <div className="flex items-center space-x-1">
          <Calendar className="w-2.5 h-2.5" />
          <span>{formatDate(trade.entryDate || trade.entry_date || trade.date)}{(trade.exitDate || trade.exit_date) ? ` → ${formatDate(trade.exitDate || trade.exit_date)}` : ''}</span>
        </div>
        {onShare && (
          <button
            onClick={e => { e.stopPropagation(); onShare(); }}
            className="flex items-center gap-1 px-1.5 py-0.5 rounded text-[11px] font-semibold"
            style={{ background: 'rgba(245,158,11,0.1)', border: '1px solid rgba(245,158,11,0.2)', color: '#f59e0b' }}
            title="Share to Forum"
          >
            <Share2 className="w-2.5 h-2.5" /> Share
          </button>
        )}
      </div>
    </button>
  );
};

export default TradeCard;
